var _defs, _sodipodinamedview;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetPass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      overflow: "hidden",
      fill: "currentColor"
    },
    viewBox: "0 0 210 220.00002",
    id: "svg4",
    sodipodidocname: "reset-pass.svg",
    width: 210,
    height: 220.00002,
    inkscapeversion: "1.1.2 (0a00cf5339, 2022-02-04)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), _sodipodinamedview || (_sodipodinamedview = /*#__PURE__*/React.createElement("sodipodinamedview", {
    id: "namedview6",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    showgrid: "false",
    inkscapezoom: 0.82714844,
    inkscapecx: 356.0425,
    inkscapecy: 396.54309,
    "inkscapewindow-width": 1920,
    "inkscapewindow-height": 1019,
    "inkscapewindow-x": 0,
    "inkscapewindow-y": 24,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent-layer": "svg4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 133.79771,176.10388 c 0,-9.96222 6.52684,-18.47682 15.77944,-21.99173 l 2.22835,5.03688 7.2255,-6.7724 0.10455,-0.0982 9.40701,-8.82658 -0.14023,0.0272 0.0539,-0.0476 c -3.02066,-0.776 -6.18156,-1.22334 -9.45764,-1.22334 -19.87999,0 -36.00142,15.18166 -36.00142,33.89587 0,11.96182 6.59924,22.456 16.54265,28.49291 l 7.88769,-7.42662 c -8.09273,-3.95224 -13.62981,-11.8908 -13.62981,-21.06629 z m 44.65965,-28.48624 -7.88769,7.42686 c 8.09274,3.94557 13.63007,11.8908 13.63007,21.05962 0,9.96865 -6.52709,18.4835 -15.77944,21.9984 l -2.22861,-5.04379 -7.2255,6.77241 -0.10428,0.0984 -9.40728,8.82634 0.1405,-0.0269 -0.0542,0.0541 C 152.5616,209.55599 155.72251,210 158.99858,210 178.87856,210 195,194.82476 195,176.10413 c 0,-11.96182 -6.59899,-22.456 -16.5424,-28.48625 z m -19.67823,-15.57849 c 10.97671,0 21.05352,3.5895 29.02779,9.54514 V 97.790314 c 0,-5.612927 -4.83488,-10.168618 -10.80027,-10.168618 H 166.20612 V 71.382079 h -0.0215 c 0.004,-0.125364 0.0215,-0.244055 0.0215,-0.369418 C 166.20612,37.316753 137.18896,10 101.40346,10 65.614419,10 36.600799,37.316753 36.600799,71.012661 c 0,0.04764 0.0034,0.09152 0.0068,0.132273 h -0.0068 V 87.621696 H 25.800276 C 19.834886,87.621696 15,92.177387 15,97.790551 V 183.0996 c 0,11.22634 9.673569,20.33772 21.600799,20.33772 h 85.507111 c -6.32914,-7.51457 -10.13073,-17.00562 -10.13073,-27.33367 0,-24.33738 20.94924,-44.06497 46.80195,-44.06497 z M 58.201607,87.621933 V 71.382315 h 0.018 c 0,-0.125363 -0.01774,-0.244054 -0.01774,-0.369409 0,-22.462671 19.343342,-40.675189 43.201613,-40.675189 23.85826,0 43.20185,18.212281 43.20185,40.675189 0,0.125355 -0.018,0.244046 -0.0218,0.369409 h 0.0218 v 16.239618 z",
    fill: "",
    id: "path2",
    style: {
      strokeWidth: 0.245621
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPass);
export default __webpack_public_path__ + "static/media/reset-pass.74a0a3645cb85d8f705fec3bec4a2f91.svg";
export { ForwardRef as ReactComponent };